export const bookingUpdateDatesConstants = {
    BOOKING_UPDATE_DATES_PENDING: 'BOOKING_UPDATE_DATES_PENDING',
    BOOKING_UPDATE_DATES_FULFILLED: 'BOOKING_UPDATE_DATES_FULFILLED',
    BOOKING_UPDATE_DATES_REJECTED: 'BOOKING_UPDATE_DATES_REJECTED',
    BOOKING_UPDATE_DATES_CLEAR: 'BOOKING_UPDATE_DATES_CLEAR',
};
